import React,{useState,useEffect} from "react";
import "./CreatePassword.css";
import { Link } from "react-router-dom";
import logo from "../../images/CMP_Logo.svg";
import left from "../../images/login_left_image.svg";
import eclipse_top from "../../images/eclipse_top.svg";
import eclipse_bottom from "../../images/eclipse_bottom.svg";
import eclipse_85 from "../../images/eclipse_85.svg";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import axios from "axios";

const CreatePassword = () => {



  return (
    <div
      style={{ overflow: "hidden" }}
      className="container-fluid d-flex justify-content-center align-items-center min-vh-100 login-main"
    >
      <div
        style={{ height: "100vh" }}
        className="row w-100 login-mobile-view-hide"
      >
        <div className="col-7 login-main-left d-flex justify-content-center align-items-center">
          <div>
            <div className="login-left-top container-fluid">
              <img className="img-fluid" src={eclipse_top} />
            </div>
            <div className="left-img-container text-start px-4">
              <img className="img-fluid" src={left} />
            </div>
            <div className="login-left-circle">
              <img className="img-fluid" src={eclipse_85} />
            </div>
            <div className="w-100 text-right">
              <div className="login-left-bottom">
                <img src={eclipse_bottom} />
              </div>
            </div>
          </div>
        </div>
        <div
          style={{ boxShadow: "-5px 5px 10px rgba(0, 0, 0, 0.2)" }}
          className="col-lg-5 col-md-5  d-flex align-items-center justify-content-center"
        >
          <div className=" w-100 col-5 login-main-right">
            <div
              style={{ padding: "0px 54px 74px 54px", position: "relative" }}
              className=" login-main-right-inner-content d-flex flex-column justify-content-center align-items-start"
            >
              <img
                style={{
                  position: "absolute",
                  top: "-60px",
                  left: "0%",
                  width: "247px",
                  backgroundColor: "white",
                }}
                src={logo}
                alt="Logo"
                className="logo img-fluid mb-5"
              />
              <h2 className="" style={{ marginTop: "90px" }}>
                Create Password
              </h2>
              <form className="w-100 mt-3">
                <div
                  style={{ position: "relative" }}
                  className="form-group text-start"
                >
                  <label htmlFor="username">New Password</label>
                  <input
                    type="password"
                    style={{ paddingLeft: "36px" }}
                    className="form-control"
                    id="username"
                    placeholder="Password"
                  />
                  <LockOpenIcon
                    style={{
                      position: "absolute",
                      top: "32px",
                      fontSize: "23px",
                      left: "10px",
                      color: "#6a6a6a",
                    }}
                    sx={{
                      minWidth: 0,
                      mr: "auto",
                      justifyContent: "center",
                    }}
                  ></LockOpenIcon>
                </div>
                <div
                  style={{ position: "relative" }}
                  className="form-group text-start"
                >
                  <label htmlFor="username">Confirm New Password</label>
                  <input
                    style={{ paddingLeft: "36px" }}
                    type="password"
                    className="form-control"
                    id="username"
                    placeholder="Password"
                  />
                  <LockOpenIcon
                    style={{
                      position: "absolute",
                      top: "32px",
                      fontSize: "23px",
                      left: "10px",
                      color: "#6a6a6a",
                    }}
                    sx={{
                      minWidth: 0,
                      mr: "auto",
                      justifyContent: "center",
                    }}
                  ></LockOpenIcon>
                </div>
                <Link to="/orderList">
                  <button type="submit" className="btn btn-primary">
                    Log In
                  </button>
                </Link>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* mobile view  */}
      <div
        style={{ overflow: "hidden" }}
        className="row w-100 login-mobile-view-show"
      >
        <div className="col-12 login-main-right d-flex justify-content-center align-items-center">
          <div className="d-flex flex-column align-items-center">
            <div className="login-right-top container-fluid text-end">
              <img className="img-fluid" src={eclipse_top} />
            </div>
            <div
              style={{ padding: "0px 23px 36px px", position: "relative" }}
              className=" login-main-right-inner-content d-flex flex-column justify-content-center align-items-start"
            >
              <img
                style={{
                  position: "absolute",
                  top: "-60px",
                  left: "0%",
                  width: "247px",
                  backgroundColor: "white",
                }}
                src={logo}
                alt="Logo"
                className="logo img-fluid mb-5"
              />
              <h2 className="" style={{ marginTop: "90px" }}>
                Create Password
              </h2>
              <form className="w-100 mt-3">
                <div
                  style={{ position: "relative" }}
                  className="form-group text-start"
                >
                  <label htmlFor="username">New Password</label>
                  <input
                    type="text"
                    style={{ paddingLeft: "36px" }}
                    className="form-control"
                    id="username"
                    placeholder="Password"
                  />
                  <LockOpenIcon
                    style={{
                      position: "absolute",
                      top: "32px",
                      fontSize: "23px",
                      left: "10px",
                      color: "#6a6a6a",
                    }}
                    sx={{
                      minWidth: 0,
                      mr: "auto",
                      justifyContent: "center",
                    }}
                  ></LockOpenIcon>
                </div>
                <div
                  style={{ position: "relative" }}
                  className="form-group text-start"
                >
                  <label htmlFor="username">Confirm New Password</label>
                  <input
                    style={{ paddingLeft: "36px" }}
                    type="text"
                    className="form-control"
                    id="username"
                    placeholder="Password"
                  />
                  <LockOpenIcon
                    style={{
                      position: "absolute",
                      top: "32px",
                      fontSize: "23px",
                      left: "10px",
                      color: "#6a6a6a",
                    }}
                    sx={{
                      minWidth: 0,
                      mr: "auto",
                      justifyContent: "center",
                    }}
                  ></LockOpenIcon>
                </div>
                <Link to="/orderList">
                  <button type="submit" className="btn btn-primary">
                    Log In
                  </button>
                </Link>
              </form>
            </div>
          </div>
          <div className="login-right-circle">
            <img className="img-fluid" src={eclipse_85} />
          </div>
          <div className="login-right-bottom"></div>
        </div>
      </div>
    </div>
  );
};

export default CreatePassword;
